import Command from '@ckeditor/ckeditor5-core/src/command';
import { Writer } from '@ckeditor/ckeditor5-core/src/editor';
import { addEmptyParagraphAfterPlugin } from 'vendor/ckeditor/plugins/utils';
import {
  ResourceTemplateSectionSchema,
  ResourceTemplateSectionIdAttr,
  ResourceTemplateSectionFilterTypeAttr,
  ResourceTemplateSectionTypeAttr,
  ResourceTemplateSectionFilterWeeksRangeAttr,
  ResourceTemplateSectionFilterRangeStrAttr,
} from './constants';
import { InsertResourcelistTemplateCommandOptions } from './types';

export class InsertResourceListSectionCommand extends Command {
  execute({
    resourceTemplateSectionId,
    resourceTemplateSectionType,
    resourceTemplateSectionFilterType,
    resourceTemplateSectionFilterRangeStr,
    resourceTemplateSectionFilterWeeksRange,
    targetRange,
  }: InsertResourcelistTemplateCommandOptions): void {
    const { editor } = this;

    editor.model.change((writer: Writer) => {
      const resourceSection = writer.createElement(
        ResourceTemplateSectionSchema,
        {
          [ResourceTemplateSectionIdAttr]: resourceTemplateSectionId,
          [ResourceTemplateSectionTypeAttr]: resourceTemplateSectionType,
          [ResourceTemplateSectionFilterTypeAttr]:
            resourceTemplateSectionFilterType,
          [ResourceTemplateSectionFilterRangeStrAttr]:
            resourceTemplateSectionFilterRangeStr,
          [ResourceTemplateSectionFilterWeeksRangeAttr]:
            resourceTemplateSectionFilterWeeksRange,
        },
      );

      editor.model.insertContent(resourceSection, targetRange);

      addEmptyParagraphAfterPlugin(editor, writer, resourceSection);

      editor.editing.view.focus();
    });
  }

  refresh(): void {
    const { model } = this.editor;
    const { selection } = model.document;
    const allowedIn = model.schema.findAllowedParent(
      selection.getFirstPosition(),
      ResourceTemplateSectionSchema,
    );

    this.isEnabled = allowedIn !== null;
  }
}
